import React, { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

interface Props {
    className?: string,
    condition?: boolean,
    to: string,
}

const ConditionLink: FunctionComponent<Props> = ({ condition, to, ...linkProps }) => {
    const url = to.replace(location.origin, '')
    return (condition !== false && to) ?
        (
            to.includes(window.location.host)?
                <Link to={url} {...linkProps}/>:
                <a href={url.replace(window.location.host, '')} {...linkProps}/>
        ):
        <div {...linkProps}/>
}

export default ConditionLink